import React from 'react';
export function Footer() {
  return <footer className="bg-black text-gray-500 py-12 border-t border-white/5" data-id="element-86">
      <div className="max-w-7xl mx-auto px-5 md:px-8 text-center" data-id="element-87">
        <div className="text-amber-500/50 font-poppins font-bold text-xl tracking-widest uppercase mb-4" data-id="element-88">
          Libro de la Sabiduría
        </div>
        <p className="text-sm mb-6" data-id="element-89">
          © {new Date().getFullYear()} Todos los derechos reservados.
        </p>
        <p className="text-xs max-w-2xl mx-auto opacity-50 leading-relaxed" data-id="element-90">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc. Los resultados
          pueden variar. El éxito depende del esfuerzo y dedicación de cada
          persona en su propio camino espiritual.
        </p>
      </div>
    </footer>;
}